export const PTT_STATES = {
  IDLE: 'idle',
  ARMING: 'arming',
  TRANSMITTING: 'transmitting',
  COOLDOWN: 'cooldown',
  BUSY: 'busy'
};
